import { type BaseUrl } from '~/types/baseUrl';

const stage = import.meta.env.MODE;

export function getBaseUrl(baseUrl: BaseUrl) {
  if (typeof baseUrl === 'string') {
    return baseUrl;
  }
  if (import.meta.env.VITE_STAGING) {
    return baseUrl["staging"];
  }
  return baseUrl[stage as keyof BaseUrl];
}
